import {
  ArchiveIcon,
  BatchActionToolbar,
  BellIcon,
  DownloadIcon,
  PlusIcon,
  SendIcon,
  TrashIcon,
  UnarchiveIcon
} from '@st/theme'
import { inflect } from '@st/util/inflect'
import { useOrganizationRole } from '../st-organizations/use-organization-role'
import { BatchActionType, STFolderAction } from './st-folder-list-module'

export function STFolderListBatchActions({
  availableBulkActions,
  selectedFolderIds,
  onClearSelection,
  onAction
}: {
  availableBulkActions: BatchActionType[]
  selectedFolderIds: string[]
  onClearSelection: () => void
  onAction: (action: STFolderAction) => void
}) {
  const organizationRole = useOrganizationRole()
  const folderActions = availableBulkActions.filter((action) => action.group == 'folder')
  const clientOrganizerActions = availableBulkActions.filter(
    (action) => action.group == 'clientOrganizer'
  )

  return (
    <BatchActionToolbar
      selectionMessage={`${selectedFolderIds.length} selected`}
      onClearSelection={onClearSelection}
    >
      <BatchActionToolbar.Section title="Binder:">
        {folderActions.map((action) => {
          switch (action.type) {
            case 'assignFolders':
              if (organizationRole == 'restricted') return null
              return (
                <BatchActionToolbar.Button
                  key={action.type}
                  icon={<AssigneeToolbarAssignIcon />}
                  onClick={() => onAction(action)}
                >
                  Assign
                </BatchActionToolbar.Button>
              )
            case 'archiveFolders':
              return (
                <BatchActionToolbar.Button
                  key={action.type}
                  icon={<ArchiveIcon className="size-4" />}
                  onClick={() => onAction(action)}
                >
                  Archive
                </BatchActionToolbar.Button>
              )
            case 'unarchiveFolders':
              return (
                <BatchActionToolbar.Button
                  key={action.type}
                  icon={<UnarchiveIcon className="size-4" />}
                  onClick={() => onAction(action)}
                >
                  Unarchive
                </BatchActionToolbar.Button>
              )
            case 'deleteFolders':
              return (
                <BatchActionToolbar.Button
                  key={action.type}
                  icon={<TrashIcon className="size-4" />}
                  onClick={() => onAction(action)}
                >
                  Delete
                </BatchActionToolbar.Button>
              )
            case 'addChecklistItems':
              return (
                <BatchActionToolbar.Button
                  key={action.type}
                  icon={<PlusIcon className="size-4" />}
                  onClick={() => onAction(action)}
                >
                  Checklist
                </BatchActionToolbar.Button>
              )
          }
        })}
      </BatchActionToolbar.Section>

      {clientOrganizerActions.length > 0 && <BatchActionToolbar.SectionDivider />}

      {clientOrganizerActions.length > 0 && (
        <BatchActionToolbar.Section title="Organizer:">
          {clientOrganizerActions.map((action) => {
            switch (action.type) {
              case 'sendClientOrganizers':
                return (
                  <BatchActionToolbar.Button
                    key={action.type}
                    icon={<SendIcon className="size-4" />}
                    onClick={() => onAction(action)}
                  >
                    Send to {inflect(selectedFolderIds.length, 'client')}
                  </BatchActionToolbar.Button>
                )
              case 'exportCsv':
                return (
                  <BatchActionToolbar.Button
                    key={action.type}
                    icon={<DownloadIcon className="size-4" />}
                    onClick={() => onAction(action)}
                  >
                    Export CSV
                  </BatchActionToolbar.Button>
                )
              case 'enrollInReminders':
                return (
                  <BatchActionToolbar.Button
                    key={action.type}
                    icon={<BellIcon className="size-4" />}
                    onClick={() => onAction(action)}
                  >
                    Enroll in reminders
                  </BatchActionToolbar.Button>
                )
              case 'unenrollFromReminders':
                return (
                  <BatchActionToolbar.Button
                    key={action.type}
                    icon={<BellIcon className="size-4" />}
                    onClick={() => onAction(action)}
                  >
                    Unenroll from reminders
                  </BatchActionToolbar.Button>
                )
            }
          })}
        </BatchActionToolbar.Section>
      )}
    </BatchActionToolbar>
  )
}

function AssigneeToolbarAssignIcon() {
  return (
    <svg className="size-4 text-gray-200" viewBox="0 0 16 16">
      <path
        fill="currentColor"
        d="M16 8.5a.5.5 0 0 1-.5.5h-1v1a.5.5 0 1 1-1 0V9h-1a.5.5 0 0 1 0-1h1V7a.5.5 0 0 1 1 0v1h1a.5.5 0 0 1 .5.5m-3.62 3.68a.5.5 0 1 1-.76.64 6.3 6.3 0 0 0-9.74 0 .5.5 0 1 1-.76-.64A7.4 7.4 0 0 1 4.5 9.85a4.25 4.25 0 1 1 4.5 0 7.5 7.5 0 0 1 3.38 2.33M6.75 9.5a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5"
      />
    </svg>
  )
}
